<template>
  <div class="modalback" @click="closeAction">
    <div class="modalcontent container">
      <div class="row justify-content-center align-items-center h-100">
          <div class="col h-100">
              <img class="img-fluid h-100 " :src="this.$store.state.imagePopupImage" /> 
          </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "ImagePopup",
  props: {},
  data: function () {
    return {
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  methods: {
    closeAction(){
      this.$store.commit("hideImagePopup")
    }
  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalback {
  z-index: 200;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  z-index: 201;
  width: 70%;
  height: 70%;
  padding: 1em;
  /* background-color: rgb(200, 200,200); */
  /* border: 3px solid rgb(215, 215, 215); */
}
</style>
